export function defaultRouteTo(url: string) {
  window.location.href = url;
}
